<template>
  <div class="after_sale_info_warp">
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">中奖记录信息</div>
      </div>
      <div class="card_content">
        <el-descriptions>
          <el-descriptions-item label="中奖姓名">{{ orderInfo.name }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ orderInfo.phone }}</el-descriptions-item>
          <el-descriptions-item label="地址">
            {{ orderInfo.countryName }}
            {{ orderInfo.provinceName }}
            {{ orderInfo.cityName }}
            <span v-if="orderInfo.areaName">{{ orderInfo.areaName }}</span>
            {{ orderInfo.address }}
          </el-descriptions-item>

          <!-- <el-descriptions-item label="快递公司">{{
                        orderInfo.expressName
                    }}</el-descriptions-item> -->

          <!-- <el-descriptions-item label="快递单号">{{
                        orderInfo.deliveryNum
                    }} <span @click="copyClick(orderInfo.deliveryNum)"
                            class="copy_key_pre">复制</span></el-descriptions-item> -->

          <!-- <el-descriptions-item label="发货时间">{{
                        formatApiDate(orderInfo.deliveryTime)
                    }}</el-descriptions-item> -->

          <el-descriptions-item label="备注">{{ orderInfo.remark }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">商品信息</div>
      </div>
      <div class="card_content">
        <el-table :data="orderInfo.goodsList" style="width: 100%" size="mini">
          <el-table-column prop="prizeName" label="奖品名称"> </el-table-column>
          <el-table-column prop="mainGraph" label="商品图" width="100">
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.iconUrl"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="parValue" label="奖品价格"> </el-table-column>

          <el-table-column prop="prizeNum" label="奖品数量"> </el-table-column>

          <el-table-column prop="expressName" label="快递公司"> </el-table-column>
          <el-table-column prop="deliveryNum" label="快递单号">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center;">
                {{ scope.row.deliveryNum }}
                <span
                  @click="copyClick(scope.row.deliveryNum)"
                  class="copy_key_pre"
                  v-if="scope.row.deliveryNum"
                  >复制</span
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="expressTime" label="卖家发货时间">
            <template slot-scope="scope">
              <span>{{ formatApiDate(scope.row.deliveryTime) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <div class="dialog-footer">
      <el-button type="primary" @click="returnList">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getPrizesLogDetail } from "@/api/raffle.js";
import { formatApiDate } from "@/utils/utils";
import { getValue, ORDER_STATUS } from "@/utils/enumUtile";
import { copyClick } from "@/utils/index.js";

export default {
  name: "orderInfo",
  computed: {
    formatApiDate() {
      return formatApiDate;
    },

    ORDER_STATUS() {
      return ORDER_STATUS;
    }
  },
  data() {
    return {
      id: 0,
      orderInfo: {},
      listLoading: false
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.id = id;
      this.getList();
    }
  },
  watch: {},
  methods: {
    getValue,
    copyClick,
    onExpressNo() {
      window.open(
        "https://www.baidu.com/s?rsv_idx=1&wd=%E6%9F%A5%E5%BF%AB%E9%80%92%E5%8D%95%E5%8F%B7%E6%9F%A5%E8%AF%A2%E5%85%A5%E5%8F%A3",
        "_blank"
      );
    },
    getList() {
      const id = this.id;
      if (!id) {
        return;
      }
      this.listLoading = true;
      const params = {
        Id: id
      };
      getPrizesLogDetail(params)
        .then(response => {
          this.orderInfo = response.data || [];
          this.orderInfo.goodsList = [
            {
              prizeName: this.orderInfo.prizeName,
              iconUrl: this.orderInfo.iconUrl,
              prizeNum: this.orderInfo.prizeNum,
              parValue: this.orderInfo.parValue,
              expressName: this.orderInfo.expressName,
              deliveryNum: this.orderInfo.deliveryNum,
              deliveryTime: this.orderInfo.deliveryTime
            }
          ];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    returnList() {
      this.$router.push({ path: "/raffle/prizesLog" });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/index";

.aa {
  display: inline-block;
}

.after_sale_info_warp {
  background-color: #eeeeee;
  padding: 20px;
  height: calc(100vh - 124px);
  overflow-y: auto;

  .box-card {
    margin-bottom: 20px;
  }

  .card_title {
    display: flex;
    align-items: center;

    .card_title_fg {
      height: 22px;
      width: 4px;
      background-color: $Theme-color;
    }

    .card_title_msg {
      margin-left: 6px;
    }
  }

  .card_content {
    margin-top: 10px;

    .descriptions_mar_warp {
      margin-top: 20px;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: end;
  }

  .copy_key_pre {
    background-color: #11b95c;
    border-radius: 4px;
    color: #ffffff;
    padding: 2px 0;
    margin-left: 10px;
    cursor: pointer;
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
